import React from "react";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";
import ProgressBar from "@ramonak/react-progress-bar";
import "./skill.css";
class Skills extends React.Component {
  render() {
    return (
      <div className="skills">
        <Fade bottom>
          <h1 className="skill-title">Skills</h1>
        </Fade>
        <div className="flex">
          <div>
            <Slide left>
              <h4>Html</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="barCompleted"
                labelClassName="label"
                completed={80}
              />
              <p></p>
            </Slide>

            <Slide left>
              <h4>CSS</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="barCompleted"
                labelClassName="label"
                completed={80}
              />
              <p></p>
            </Slide>

            <Slide left>
              <h4>JavaScript</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="js"
                labelClassName="label"
                completed={60}
              />
              <p></p>
            </Slide>

            <Slide left>
              <h4>Php</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="php"
                labelClassName="label"
                completed={60}
              />
              <p></p>
            </Slide>
          </div>

          <div>
            <Slide right>
              <h4>React js</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="react"
                labelClassName="label"
                completed={80}
              />
              <p></p>
            </Slide>

            <Slide right>
              <h4>Bootstrap</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="boot"
                labelClassName="label"
                completed={80}
              />
              <p></p>
            </Slide>

            <Slide right>
              <h4>Git</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="git"
                labelClassName="label"
                completed={80}
              />
              <p></p>
            </Slide>

            <Slide right>
              <h4>Figma</h4>
              <ProgressBar
                className="wrapper"
                barContainerClassName="container"
                completedClassName="fig"
                labelClassName="label"
                completed={60}
              />
              <p></p>
            </Slide>
          </div>
        </div>

        <div className="explored-ctn">
          <Slide bottom>
            <h2>Explored</h2>
          </Slide>
          <Slide left>
            <p>
              <span className="ep-title">Languages : </span>Python, Java, C,
              C++, R{" "}
            </p>
          </Slide>
          <Slide left>
            <p>
              <span className="ep-title">Frameworks : </span>Express Js
            </p>
          </Slide>
          <Slide left>
            <p>
              <span className="ep-title">Databases : </span>MySQL, MongoDB,
              Firestore
            </p>
          </Slide>
          <Slide left>
            <p>
              <span className="ep-title">Tools : </span>Docker
            </p>
          </Slide>
        </div>
      </div>
    );
  }
}

export default Skills;
